export type TextDirection = "ltr" | "rtl";

// The editor's markup has no base direction, so every cue box inherits the document's LTR.
// For Arabic the glyphs still shape correctly, which is why this looks fine at a glance —
// but the sentence-final punctuation lands on the wrong edge and any embedded Latin run
// (a name, a number, a URL) is reordered. The translator reads a sentence they did not
// write and "corrects" text that was already right.
const RTL_LANGS = new Set(["ar", "he", "iw", "fa", "ur"]);

export const getTextDirection = (lang?: string | null): TextDirection => {
    if (!lang) {
        return "ltr";
    }
    // The wire sends bare codes ("ar"), but a regional or cased tag ("ar-SA", "AR") must
    // not quietly fall back to LTR — that failure is invisible until a translator complains.
    const base = lang.toLowerCase().split(/[-_]/)[0];
    return RTL_LANGS.has(base) ? "rtl" : "ltr";
};
